import React, { useState,useEffect } from 'react';
import { NavLink} from "react-router-dom";
import { dynamicUrl } from './Function';
import { ListGroup,Placeholder,OverlayTrigger,Popover,Button,Nav } from 'react-bootstrap';
const SidebarMenu = ({ menuData }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[menu,setMenu]=useState([]);
    const [showPopover, setShowPopover] = useState(false);
    const handleTogglePopover = () => setShowPopover(!showPopover);
    const handleClosePopover = () => setShowPopover(false);
    if( global.config.IsPrint === true ) { console.info('Menu : ',menu) }
    useEffect(()=>
    {
        if(menuData)
        {
            setMenu(menuData);
            setLoading(false);
        }
        // eslint-disable-next-line
    },[menuData])
    
    return (
        <React.Fragment>
        {isLoading ? (
            <React.Fragment>
            {[...Array(10)].map((_,index)=>(
                <ListGroup.Item key={index} data-aos="flip-up" data-aos-duration="1500">
                    <Placeholder xs={12} />
                </ListGroup.Item>                               
            ))}
            </React.Fragment>
        ) : (
            <React.Fragment>
            {menu.sp_id !== 20 && menu.submenu && menu.submenu.length > 0 ? (
                <React.Fragment>
                <ListGroup.Item className={window.location.pathname.includes(dynamicUrl(menu)) || 
             menu.submenu.some(submenu => window.location.pathname.includes(dynamicUrl(submenu))) 
             ? 'active' 
             : ''} data-aos="flip-up" data-aos-duration="1500" data-id={menu.sp_id}>
                    <NavLink to={dynamicUrl(menu)} className={({ isActive }) => (isActive ? 'active link-light' : 'link-light')}>{( appLanguage === 'hi' && menu.sp_name_hi ) ? menu.sp_name_hi : menu.sp_name }</NavLink>
                    <OverlayTrigger trigger="click" key="bottom" placement="bottom" show={showPopover} onToggle={handleTogglePopover} overlay={
                        <Popover id="popover-positioned-bottom">
                            <Popover.Body>
                                <SubMenu submenus={menu.submenu} onClose={handleClosePopover} />
                            </Popover.Body>
                        </Popover>
                        }>
                        <Button variant="link" className='p-0 ms-2 link-light'>
                            <i className="bi bi-caret-down-fill"></i>
                            <span className="visually-hidden">{appLanguage === 'hi' ? 'उप पृष्ठ देखने के लिए क्लिक करें' : 'Click to view sub page'}</span>
                        </Button>
                    </OverlayTrigger>                 
                </ListGroup.Item>
                </React.Fragment>
            ) : (
                <NavLink 
                to={dynamicUrl(menu)} 
                className={({ isActive }) => 
                    (isActive ? 'list-group-item list-group-item-action active' : 'list-group-item list-group-item-action')
                }
                end
                data-aos="flip-up" 
                data-aos-duration="1500" 
                data-id={menu.sp_id}
                >
                    {(appLanguage === 'hi' && menu.sp_name_hi) ? menu.sp_name_hi : menu.sp_name}
                </NavLink>
            )}            
            </React.Fragment>
        )}        
        </React.Fragment>
    );
};
export default SidebarMenu;
const SubMenu = ({ submenus,onClose }) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return (
        <Nav className="flex-column">
            {submenus.map((submenu,index) => (
                <React.Fragment key={index}>
                <NavLink to={dynamicUrl(submenu)} onClick={onClose} className={({ isActive }) => (isActive ? 'active nav-link' : 'nav-link')} data-id={submenu.sp_id}>
                    {( appLanguage === 'hi' && submenu.sp_name_hi ) ? submenu.sp_name_hi : submenu.sp_name }                    
                </NavLink>
                {submenu.submenu && submenu.submenu.length > 0 ? (
                    <SubMenuOfSubMenu submenus={submenu.submenu} onClose={onClose} />
                ) : null}
                </React.Fragment>
            ))}
        </Nav>
    );
};
const SubMenuOfSubMenu = ({ submenus,onClose }) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return (
        <React.Fragment>
        {submenus.map((submenu,index) => (
            <NavLink key={index} to={dynamicUrl(submenu)} onClick={onClose} className={({ isActive }) => (isActive ? 'active nav-link' : 'nav-link')} data-id={submenu.sp_id}>
                <span className='ms-2'><i className="bi bi-dot"></i> {( appLanguage === 'hi' && submenu.sp_name_hi ) ? submenu.sp_name_hi : submenu.sp_name }</span>
            </NavLink>
        ))}
        </React.Fragment>        
    );
};